import { useForm } from 'vee-validate'
import * as yup from 'yup'

export default class defineValidation {
  constructor (setting) {
    this.schema = null
    this.createdFields = null
    this.initialValues = {}
    this.form = null
    this.models = null
    this.mapFieldModels = null
    return this._define(setting)
  }

  _define (setting) {
    this.schema = yup.object(setting(yup))
    this._getCreatedFields()
    this._createInitialValues()
    this.form = useForm({
      validationSchema: this.schema,
      initialValues: this.initialValues
    })
    // console.log(this.form)
    this.models = this.form.useFieldModel(this.createdFields)
    this._createMapFieldModels()
    const bundle = { ...this.form, ...{ models: this.mapFieldModels } }
    return bundle
  }

  _getCreatedFields () {
    this.createdFields = Object.keys(this.schema.fields)
  }

  _createInitialValues () {
    this.createdFields.forEach(key => {
      this.initialValues[key] = ''
    })
  }

  _createMapFieldModels () {
    const mapFieldModels = {}
    this.createdFields.forEach((key, index) => {
      mapFieldModels[key] = this.models[index]
    })
    this.mapFieldModels = mapFieldModels
  }
}
